/**
 * The icon set, assembled by hand.
 *
 * The design system's Icon component looks names up in `window.lucide.icons`.
 * Importing lucide's barrel would pull in all ~1743 icons and add roughly
 * 700 kB for the few dozen this app uses, so each is imported individually and
 * the lookup table is built here — same approach as website-main and
 * website-cloud.
 *
 * Icon renders `icons[pascal(name)] || icons[name]`, so keys are PascalCase.
 * A missing entry renders nothing at all rather than throwing, so grep this
 * file first if an icon goes blank.
 *
 * The status icons at the top are load-bearing rather than decorative: a status
 * colour must never carry meaning alone, so every state pill on this site pairs
 * its colour with one of these and a word.
 */

import {
  Activity,
  AlertTriangle,
  ArrowLeft,
  Bell,
  Calendar,
  Check,
  CheckCircle2,
  ChevronDown,
  ChevronRight,
  Circle,
  Clock,
  Copy,
  ExternalLink,
  Eye,
  EyeOff,
  Gauge,
  Globe,
  Info,
  Link2,
  Loader,
  Mail,
  MinusCircle,
  Moon,
  Pause,
  Pencil,
  Play,
  Plus,
  RefreshCw,
  Save,
  Search,
  Settings,
  Shield,
  Sun,
  Terminal,
  Trash2,
  TriangleAlert,
  Users,
  Wrench,
  X,
  XCircle,
  Zap
} from 'lucide';

export const iconSet = {
  Activity,
  AlertTriangle,
  ArrowLeft,
  Bell,
  Calendar,
  Check,
  CheckCircle2,
  ChevronDown,
  ChevronRight,
  Circle,
  Clock,
  Copy,
  ExternalLink,
  Eye,
  EyeOff,
  Gauge,
  Globe,
  Info,
  Link2,
  Loader,
  Mail,
  MinusCircle,
  Moon,
  Pause,
  Pencil,
  Play,
  Plus,
  RefreshCw,
  Save,
  Search,
  Settings,
  Shield,
  Sun,
  Terminal,
  Trash2,
  TriangleAlert,
  Users,
  Wrench,
  X,
  XCircle,
  Zap
};
